import PropTypes from "prop-types";

export default {
  id: PropTypes.string,
  name: PropTypes.string,
  status: PropTypes.string,
  type: PropTypes.string,
};
